import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './Certifications.css';

export interface CertificationsProps {
  certifications: AboutContentDto['certifications'];
}

export function Certifications({ certifications }: CertificationsProps) {
  if (certifications.length === 0) {
    return null;
  }
  return (
    <section className="dma-certifications" aria-labelledby="dma-certifications-heading">
      <Container>
        <h2 id="dma-certifications-heading">گواهی‌نامه‌ها و افتخارات</h2>
        <div className="dma-certifications__grid">
          {certifications.map((cert) => (
            <Card key={cert.title} className="dma-certifications__item">
              <img
                src={cert.image}
                alt={cert.title}
                loading="lazy"
                className="dma-certifications__image"
              />
              <h3 className="dma-certifications__title">{cert.title}</h3>
              <p className="dma-certifications__meta">
                {cert.issuer} · {cert.year}
              </p>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
